import { NavLink, useLocation } from 'react-router-dom'

import {
  Sidebar,
  SidebarContent,
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  useSidebar,
} from '@/components/ui/sidebar'
import { screensByGroup } from '@/configs/screens'

/**
 * Main navigation on the shadcn Sidebar primitives: a collapsible column on
 * desktop, a Sheet drawer at ≤900px (focus trap, Escape, and scrim come
 * from Radix; breakpoint set in use-mobile.ts). Groups and items derive
 * from the SCREENS table.
 */
function AppSidebar() {
  const { pathname } = useLocation()
  const { isMobile, setOpenMobile } = useSidebar()

  const isActive = (route: string) => pathname.startsWith(route)

  return (
    <Sidebar
      collapsible="offcanvas"
      className="top-(--topbar-h) h-[calc(100svh-var(--topbar-h))]"
    >
      <SidebarContent>
        <nav aria-label="Main navigation">
          {screensByGroup().map((group) => (
            <SidebarGroup key={group.label}>
              <SidebarGroupLabel>{group.label}</SidebarGroupLabel>
              <SidebarGroupContent>
                <SidebarMenu>
                  {group.items.map((screen) => {
                    const ItemIcon = screen.icon
                    return (
                      <SidebarMenuItem key={screen.route}>
                        {/* shadcn uses --sidebar-accent for BOTH hover and
                            active, so adjacent items blur together. Split
                            them: hover recolors the text only (brand
                            hover-blue); the clicked tab alone gets the full
                            highlight — tint + dark text. min-h-11 lifts the
                            vendored h-8 default to the 44px touch minimum
                            (React_Web_Standards §11.1) — the drawer is the
                            primary touch surface. */}
                        <SidebarMenuButton
                          asChild
                          isActive={isActive(screen.route)}
                          className="min-h-11 hover:bg-transparent hover:text-(--link-hover) data-[active=true]:bg-(--surface-selected) data-[active=true]:text-(--blattner-dark-blue) data-[active=true]:hover:bg-(--surface-selected) data-[active=true]:hover:text-(--blattner-dark-blue)"
                        >
                          <NavLink
                            to={screen.route}
                            onClick={() => {
                              if (isMobile) setOpenMobile(false)
                            }}
                          >
                            <ItemIcon aria-hidden="true" />
                            <span>{screen.label}</span>
                          </NavLink>
                        </SidebarMenuButton>
                      </SidebarMenuItem>
                    )
                  })}
                </SidebarMenu>
              </SidebarGroupContent>
            </SidebarGroup>
          ))}
        </nav>
      </SidebarContent>
    </Sidebar>
  )
}

export default AppSidebar
